/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Admin_OnlyInputs */

const cs_pm_admin_only = /** @type {(inputs: Pm_Admin_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapování může spustit jen administrátor kanceláře.`)
};

const en_pm_admin_only = /** @type {(inputs: Pm_Admin_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only office admins can run the mapping.`)
};

/**
* | output |
* | --- |
* | "Only office admins can run the mapping." |
*
* @param {Pm_Admin_OnlyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_admin_only = /** @type {((inputs?: Pm_Admin_OnlyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Admin_OnlyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_admin_only(inputs)
	return cs_pm_admin_only(inputs)
});